var _path, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.732422 10.3711C0.732422 4.84825 5.20957 0.371094 10.7324 0.371094H33.541C39.0639 0.371094 43.541 4.84825 43.541 10.3711V33.1797C43.541 38.7025 39.0639 43.1797 33.541 43.1797H10.7324C5.20957 43.1797 0.732422 38.7025 0.732422 33.1797V10.3711Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.47,
    cy: 16.1087,
    r: 3.33328,
    fill: "#F32A00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.803,
    cy: 16.1087,
    r: 3.33328,
    fill: "#F79A00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.47,
    cy: 27.4427,
    r: 3.33328,
    fill: "#86BB00"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.804,
    cy: 27.4427,
    r: 3.33328,
    fill: "#29C18C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendIcon);
export default __webpack_public_path__ + "static/media/legendIcon.fe6cfedbf838915751b5bd16b89d19b5.svg";
export { ForwardRef as ReactComponent };